import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { urlConfig } from '../../config';
import { useAppContext } from '../../context/AuthContext';
import Logo from '../common/Logo';

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const navigate = useNavigate();
    const { setIsLoggedIn, setUserName } = useAppContext();
    const bearerToken = sessionStorage.getItem('auth-token');

    useEffect(() => {
        if (bearerToken) navigate('/app');
    }, [bearerToken, navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${urlConfig.backendUrl}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearerToken || ''}`
                },
                body: JSON.stringify({ email, password })
            });
            const data = await response.json();

            if (response.ok) {
                sessionStorage.setItem('auth-token', data.authtoken);
                sessionStorage.setItem('email', data.userEmail);
                sessionStorage.setItem('name', data.userName);
                setIsLoggedIn(true);
                setUserName(data.userName);
                navigate('/app');
            } else {
                setPassword('');
                setErrorMessage(data.error || 'Invalid credentials');
            }
        } catch (e) {
            setErrorMessage('Sign in failed. Please try again.');
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-card__brand">
                    <Logo size={24} />
                    GiftLink
                </div>
                <h2>Welcome back</h2>
                <p className="auth-card__subtitle">Sign in to browse listings and connect with givers in your community.</p>

                {errorMessage && <div className="auth-error">{errorMessage}</div>}

                <form onSubmit={handleLogin}>
                    <div className="auth-field">
                        <label htmlFor="login-email">Email</label>
                        <input id="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div className="auth-field">
                        <label htmlFor="login-password">Password</label>
                        <input id="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                    <button type="submit" className="btn-gift btn-gift-primary">Sign in</button>
                </form>

                <p className="auth-card__footer">
                    Don't have an account? <Link to="/app/register">Register</Link>
                </p>
            </div>
        </div>
    );
}

export default LoginPage;
